/**
 * Timing Constants
 * Shared setTimeout delays and timing values
 * @module @shared/constants
 */

/**
 * Standard setTimeout delays (in milliseconds)
 * Used for async operations, loading states, and debouncing
 */
export const TIMING_DELAYS = {
  INSTANT: 0,
  FAST: 150,
  FASTER: 200,
  BASE: 300,
  NORMAL: 400,
  SLOW: 500,
  SLOWER: 800,
  VERY_SLOW: 1000,
  EXTRA_SLOW: 1200,
} as const;

/**
 * Tooltip delay (in milliseconds)
 */
export const TOOLTIP_DELAY = 200;

/**
 * Default toast duration (in milliseconds)
 */
export const TOAST_DURATION = 3000;

/**
 * Debounce delays (in milliseconds)
 */
export const DEBOUNCE_DELAYS = {
  SEARCH: 300,
  RESIZE: 200,
  INPUT: 500,
} as const;
